import { IBlock, ITelegramKeyboardBlock } from 'common/builder/blocks/blockInterfaces'
import {
  ConverterRule,
  BlockConverterRulePayload,
} from 'common/builder/components/chart/FlowChart/lib/types'
import { getButtonsFromMap } from 'common/builder/components/chart/FlowChart/lib/utils/getButtonsFromMap'
import { FlowChartBlockType } from 'common/builder/components/chart/FlowChart/types/FlowChartBlock'
import {
  FlowChartTelegramKeyboardBlock,
  TelegramKeyboardBlockButtonsRow,
} from 'common/builder/components/chart/FlowChart/types/FlowChartTelegramKeyboardBlock'
import { BlockType } from 'common/builder/constants/BlockType'

export const KeyboardBlockTelegramConverterRule: ConverterRule<
  ITelegramKeyboardBlock,
  FlowChartTelegramKeyboardBlock,
  BlockConverterRulePayload
> = {
  predicate: (entity: IBlock) => entity?.type === BlockType.TELEGRAM_KEYBOARD,
  convert: (entity: ITelegramKeyboardBlock, { flowChartButtons }) => {
    if (entity.buttonsStructure.length === 0 || entity.buttonsStructure[0].length === 0) {
      return null
    }

    return {
      id: entity.id,
      type: FlowChartBlockType.TELEGRAM_KEYBOARD,
      data: {
        buttonRows: entity.buttonsStructure.map(
          (row): TelegramKeyboardBlockButtonsRow => ({
            buttons: getButtonsFromMap(row, flowChartButtons),
          }),
        ),
      },
    }
  },
}
